import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门专区',
    links: [
      { label: '明星黑料', href: '/category/celebrity-gossip' },
      { label: '热门吃瓜', href: '/category/hot-gossip' },
      { label: '深度解析', href: '/category/deep-analysis' },
      { label: '娱乐爆料', href: '/category/entertainment-leaks' },
      { label: '莫里秀找爹', href: '/category/maury-show' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '关于我们', href: '/about' },
      { label: '热门标签', href: '/' },
      { label: '免责声明', href: '/about' },
    ],
  },
  {
    title: '联系我们',
    links: [
      { label: '商务合作', href: '/about' },
      { label: '投稿爆料', href: '/about' },
      { label: '意见反馈', href: '/about' },
    ],
  },
  {
    title: '关注我们',
    links: [
      { label: '微信公众号', href: '/about' },
      { label: '微博', href: '/about' },
      { label: '抖音', href: '/about' },
      { label: '小红书', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        {/* Top: Link Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3 whitespace-nowrap">
                {col.title}
              </h4>
              <div className="h-px w-8 bg-accent-400 mb-4" />
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="my-10 md:my-14 h-px bg-background-200/70" />

        {/* Bottom: Brand + Copyright */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-1 mb-2">
              <span className="text-2xl md:text-3xl font-black text-accent-500">51</span>
              <span className="text-2xl md:text-3xl font-black text-foreground-950">CG</span>
              <span className="text-lg md:text-xl font-bold text-foreground-700 ml-1">吃瓜特色</span>
            </div>
            <div className="h-px w-16 bg-accent-400 mb-3" />
            <p className="text-xs md:text-sm text-foreground-500 max-w-md leading-relaxed">
              51CG吃瓜特色是汇集最新热门瓜料、明星黑料、娱乐爆料与网友热议话题的综合性吃瓜导航与深度解析平台。
            </p>
          </div>

          <div className="flex flex-col md:items-end gap-3">
            <p className="text-xs text-foreground-400">
              © 2026 51CG吃瓜特色. 保留所有权利.
            </p>
            <div className="flex items-center gap-3">
              {['ri-wechat-fill', 'ri-weibo-fill', 'ri-tiktok-fill', 'ri-instagram-line'].map((icon) => (
                <a
                  key={icon}
                  href="/about"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-colors"
                  aria-label="社交媒体"
                  rel="nofollow"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}